



























































import { Component, Prop, Vue } from 'vue-property-decorator'
import axiosInstance from '@/plugins/axios'
import { AxiosResponse } from 'axios'
import { EventBus, FILE_UPLOADED } from '@/plugins/eventBus'
import { ApiError } from '@/definitions/apiError'

@Component({
  name: 'upload-modal',
  components: {}
})
export default class UploadModal extends Vue {
  @Prop()
  type: string

  @Prop()
  fileName: string

  isLoading = false

  isBypassStudentId = false
  isBypassFees = false

  errorMessages: string[] = []
  textInput = ''
  fileInput: File = null

  get isFeeFile () {
    return this.type === 'FEE'
  }

  get isBypassableError () {
    return this.isBypassStudentId || this.isBypassFees
  }

  get modalProps () {
    return !this.fileName ? {
      header: `Create New File (${this.isFeeFile ? 'Fees' : 'Scores'})`,
      textLabel: 'File name',
      textPlaceholder: this.isFeeFile ? 'CampusA Primary 2023-2024' : 'Primary 5/A 2023-2024'
    } : {
      header: `Update: ${this.fileName}`,
      textLabel: 'Update description',
      textPlaceholder: this.isFeeFile ? 'Changing LAK fee to 250,000 Kip' : "Update Vithaya's Maths score"
    }
  }

  upload () {
    if (!this.fileInput) {
      return this.$buefy.dialog.alert({
        title: 'No file selected',
        message: 'Please select a file to upload',
        type: 'is-danger'
      })
    }

    this.isLoading = true

    const formData = new FormData()
    formData.append('file', this.fileInput)
    if (this.fileName) {
      formData.append('fileName', this.fileName)
      formData.append('description', this.textInput)
    } else {
      formData.append('fileName', this.textInput)
    }

    if (this.isFeeFile) {
      formData.append('bypassDuplicatedStudentId', this.isBypassStudentId ? 'true' : 'false')
      formData.append('bypassUploadNewFileInsteadOfUpdate', this.isBypassFees ? 'true' : 'false')
    }

    axiosInstance.post(
      `${this.isFeeFile ? '/fees' : '/scores'}`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } })
      .then((response: AxiosResponse) => {
        const file: IFile = response.data
        EventBus.$emit(FILE_UPLOADED, file)
        this.$emit('close')
      })
      .catch((error: ApiError) => {
        if (this.isFeeFile) {
          /* duplicated id, allow bypass ? */
          this.isBypassStudentId = this.isBypassStudentId || (error.status === 423 && error.bypassType === 'STUDENTID')
          this.isBypassFees = this.isBypassFees || (error.status === 423 && error.bypassType === 'FEE')
        }

        if (error.errors) {
          this.errorMessages = error.errors.map(err => err.message)
        } else {
          this.errorMessages = [error.message]
        }
      })
      .finally(() => {
        this.isLoading = false
      })
  }
}
